import React from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import MascotasReporte from "./MascotasReporte";
import LoadingScreen from "../../organisms/LoadingScreen";
import { useNavigate } from "react-router-dom";
import { RUTA_COMUNICACIONES } from "../../../services/rutas";
import { useExisteListaAsistenciaDeHoy } from "../../../services/asistenciaServicios";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/comunicaciones",
    label: "Comunicaciones",
  },
  {
    path: "/reporte_diario",
    label: "Reporte diario",
    isActive: true,
  },
];

function ReporteDiario() {
  const navigate = useNavigate();
  const {
    data: existeListaDeAsistenciaDeHoy,
    isLoading: existeListaDeAsistenciaDeHoyIsLoading,
    isSuccess: existeListaDeAsistenciaDeHoyIsSuccess,
    error: existeListaDeAsistenciaDeHoyError,
  } = useExisteListaAsistenciaDeHoy();

  const error = existeListaDeAsistenciaDeHoyError;

  if (error) {
    return <ServerErrorModal />;
  }

  if (existeListaDeAsistenciaDeHoyIsLoading) {
    return <LoadingScreen isLoading={true} />;
  }

  const onVolverClick = () => {
    navigate(RUTA_COMUNICACIONES);
  };

  return (
    <Page
      title="Reporte diario"
      description="Registro y envío de información del estado diario de las mascotas."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <Col className="col-xs-11 col-md-8 col-lg-6 col-xl-4">
          {existeListaDeAsistenciaDeHoy &&
            existeListaDeAsistenciaDeHoyIsSuccess && <MascotasReporte />}
          {!existeListaDeAsistenciaDeHoy &&
            existeListaDeAsistenciaDeHoyIsSuccess && (
              <Modal show={true} centered>
                <Modal.Header>
                  <Modal.Title>Información</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  No hay mascotas a reportar el día de hoy
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={onVolverClick}>Volver</Button>
                </Modal.Footer>
              </Modal>
            )}
        </Col>
      </Row>
    </Page>
  );
}

export default ReporteDiario;
